
export default {
  name: "StoreInfo",
  props: {
    storeInfo: { type: Object, default: () => {} },
    services: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    openingHours() {
      return this.storeInfo.openingHours.replace(/\n/g, "<br />")
    }
  },
  methods: {
    getServiceImgUrl(id) {
      return this.services.find(item => item.id == id)?.imgUrl
    }
  }
}
